(ns manage.adset-decision-tree-page.view.side-panel.node-outcomes
  (:require ["@dnd-kit/core" :as dnd-core]
            ["@dnd-kit/sortable" :as dnd-sortable]
            ["@dnd-kit/utilities" :as dnd-utilities]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/List$default" :as List]
            ["@mui/material/SvgIcon$default" :as SvgIcon]
            ["@mui/material/Typography$default" :as Typography]
            ["react" :as react]
            [cljs-bean.core :refer [->clj ->js]]
            [common.util :refer [spread-props]]
            [manage.adset-decision-tree-page.event :as event]
            [manage.adset-decision-tree-page.node-library :as node-library]
            [manage.adset-decision-tree-page.sub :as-alias sub]
            [manage.adset-decision-tree-page.view.common
             :refer [outcome-label side-panel-list-item upgrade-ad-variants-button]]
            [manage.adset-decision-tree-page.view.hook :as hook]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui item
  [{:keys [on-select label drag-icon-props on-delete drag-disabled node]}]
  (let [{:keys [on-upgrade]} (hook/use-node-ad-variant-controls node)]
    ($ side-panel-list-item {:on-click on-select
                             :sx #js {:height 44}}
       ($ Icon (if drag-disabled
                 {:color "disabled"}
                 drag-icon-props)
          "drag_indicator")
       ($ outcome-label {:label label})
       (when on-upgrade
         ($ upgrade-ad-variants-button {:on-upgrade on-upgrade}))
       (when-not (nil? on-delete)
         ($ IconButton {:on-click (fn [e]
                                    (.stopPropagation e)
                                    (on-delete e {:clear-selection false}))
                        :color "grey.80"
                        :sx #js {:visibility (when (nil? on-delete) "hidden")}}
            ($ Icon "delete_outline"))))))

(defui outcome-item [{:keys [id drag-disabled]}]
  (let [sortable   (dnd-sortable/useSortable #js {:id id})
        setNodeRef (.-setNodeRef sortable)
        attributes (.-attributes sortable)
        listeners  (.-listeners sortable)
        transform  (.-transform sortable)
        transition (.-transition sortable)
        style #js {:transform (dnd-utilities/CSS.Transform.toString transform)
                   :transition transition}
        {:keys [label] :as node} (use-subscribe [::sub/node-data id])
        outcome-control (hook/use-node-outcome-control node)]
    ;; This element is the Draggable root.
    ($ :div {:ref setNodeRef
             :style style}
       ($ item (merge {:label label
                       :drag-icon-props (spread-props #js {:sx #js {:cursor "grab"}}
                                                      attributes
                                                      listeners)
                       :node node
                       :drag-disabled drag-disabled}
                      outcome-control)))))

(defui outcome-items
  [{:keys [outcome-node-ids id] {:keys [empty-text]} :outcome-properties}]
  (let [sensors (dnd-core/useSensors
                 (dnd-core/useSensor dnd-core/PointerSensor)
                 (dnd-core/useSensor dnd-core/KeyboardSensor
                                     #js {:coordinateGetter dnd-sortable/sortableKeyboardCoordinates}))
        [items set-items] (react/useState (fn [] (->js outcome-node-ids)))

        ;; Updates the items if the outcomes has changed (e.g. addition / removal / save failure revert)
        _ (uix/use-effect (fn []
                            (set-items (fn [items]
                                         (if (not= outcome-node-ids (vec items))
                                           (->js outcome-node-ids)
                                           items))))
                          [outcome-node-ids])

        handleDragEnd (uix/use-callback (fn [^js event]
                                          (let [active-id (-> event .-active .-id)
                                                over-id (-> event .-over .-id)]
                                            (when (not= active-id over-id)
                                              ;; Update the local state, to make dndkit work without animation glitches.
                                              (set-items (fn [items]
                                                           (let [old-index (-> items (.indexOf active-id))
                                                                 new-index (-> items (.indexOf over-id))]
                                                             (dnd-sortable/arrayMove items old-index new-index))))
                                              ;; Update the re-frame data (source of truth in the app)
                                              (rf/dispatch [::event/reorder-outcome-node id active-id over-id]))))
                                        [id])
        {default-active? :active :as default-outcome-node-control}
        (hook/use-default-outcome-node-control {:id id})]
    (if (or (seq items) default-active?)
      ($ List {:sx #js {:pb 0}}
         (when (seq items)
           (if (= (count items) 1) ; No DnD when there's only one outcome
             ($ outcome-item {:id (first items)
                              :drag-disabled true})
             ($ dnd-core/DndContext
                {:sensors sensors
                 :collisionDetection dnd-core/closestCenter
                 :onDragEnd handleDragEnd}
                ($ dnd-sortable/SortableContext
                   {:items items
                    :strategy dnd-sortable/verticalListSortingStrategy}
                   ($ :<>
                      (for [outcome-id items]
                        ($ outcome-item {:id outcome-id :key outcome-id})))))))
         (when default-active?
           ($ item (assoc default-outcome-node-control
                          :label "Default"
                          :drag-disabled true))))
      ($ Typography {:sx #js {:color "grey"}}
         (or empty-text "Strategy outcomes will be added here.")))))

(defui node-outcomes-editor [{:keys [selected-node]}]
  (let [{:keys [on-add-outcome]} (hook/use-node-controls selected-node)
        {:keys [label icon]} (get node-library/node-control-mapping :on-add-outcome)]
    ($ :<>
       (when on-add-outcome
         ($ Button
            {:startIcon ($ SvgIcon {:component icon})
             :onClick on-add-outcome
             :variant "contained"
             :color "grey"
             :sx #js {:alignSelf "end"}}
            label))
       ($ outcome-items selected-node))))
